import { Component,  Input, ViewChild } from '@angular/core';
import { BrandingData } from 'globals/store/publish.data';
import { LogisticsShareable } from 'globals/store/share.data';
import { ProgramLogisticsDisplayOptions } from 'globals/store/programs.data';
import { LogisticsViewComponent } from './logistics-view.component';
import publicHelpers from '../../helpers/public-helpers';
import { LogisticsEvent, LogisticsShareData } from 'globals/store/logistics.data';
import { CommonModule } from '@angular/common';
import { SharedTimelineComponent } from 'src/app/components/wrappers/shared-timeline-wrapper.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';

@Component({
    selector: 'logistics-share-view',
    template: `
<branding-wrapper [brandingData]="brandingData" 
  [ngClass]="{ noBranding: !brandingData }"
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'"
>
  <div class="loading" *ngIf="!!loading">loading...</div>
  <div class="error" *ngIf="!!unavailable" [innerHTML]="helpers.strWithBreak(unavailableMessage)"></div>

  <ng-container *ngIf="shareData && logisticsShareable">
    <!--<div class="extra-filters">
      <div style="flex:1;"></div>
      <icon [icon]="'grow'" (click)="$event.stopPropagation(); expandAll()"></icon>
      <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll()"></icon>
    </div>-->
    <shared-timeline-wrapper
      [eventTitle]="shareData?.logisticsEvent?.title"
      [title]="logisticsShareable?.title"
      [description]="logisticsShareable?.description"
      [loading]="loading"
      [madeWithJoi]="!logisticsShareable?.excludedFieldIds.includes(ProgramLogisticsDisplayOptions.madeWithJoi)"
      [unavailable]="unavailable"
      [unavailableMessage]="unavailableMessage"
      [showExtraFilters]="true"
      [showExpandContract]="true"
      (expandAll)="expandAll()"
      (collapseAll)="collapseAll()"
    >
      <logistics-view
        #logisticsView
        [logisticsEvent]="shareData.logisticsEvent"
        [canViewStagingRequests]="shareData.canViewStagingRequests"
        [programs]="shareData.programs"
        [program_labels]="shareData.program_labels"
        [session_labels]="shareData.session_labels"
        [excludedFieldIds]="logisticsShareable.excludedFieldIds"
        [exhibitorStandIdsByProgramId]="shareData.exhibitorStandIdsByProgramId"
        [tagDataMap]="shareData.tagDataMap"
        [sessionMap]="shareData.sessionMap"
      ></logistics-view>
    </shared-timeline-wrapper>
  </ng-container>
</branding-wrapper>
`,
    styles: [`
  .extra-filters { display: flex; align-items: center; color: var(--primary); margin-right: 20px; cursor: pointer; }
  :host ::ng-deep shared-timeline-wrapper .publish-header { padding-bottom: 10px; }
`],
    standalone: true,
    imports: [LogisticsViewComponent, BrandingWrapperComponent, SharedTimelineComponent, CommonModule],
})
export class LogisticsShareView {
  @Input() logisticsShareable: LogisticsShareable
  @Input() shareData: LogisticsShareData
  @Input() brandingData: BrandingData
  @Input() loading: boolean
  @Input() unavailable: boolean
  helpers = publicHelpers
  ProgramLogisticsDisplayOptions = ProgramLogisticsDisplayOptions
  unavailableMessage = "The production view is not currently available."

  @ViewChild('logisticsView') logisticsView: LogisticsViewComponent<LogisticsEvent>

  expandAll() {
    this.logisticsView.expandAll()
  }

  collapseAll() {
    this.logisticsView.collapseAll()
  }

}

